import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from '../../../../../Components/CustomInput';
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AssignmentDrawer from '../Assignment/AssignmentDrawer';

const useStyles = makeStyles((theme) => ({
    formWrapper: {
        background: "#fff",
        width: "400px",
        padding: theme.spacing(3),
    },
    title: {
        textTransform: "capitalize",
    },
    dialog_title: {
        "& h6": {
            fontWeight: "700"
        }
    }
}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h2">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const AssignmentModal = (props) => {
    const { open, onCloseAssignmentModal, coachingRequest, CoachinRequest } = props;
    const classes = useStyles();
    const [dropDownValue, setDropDownValue] = useState(undefined);
    const [programData, setProgramData] = useState([]);
    const [assignmentDrawer, setAssignmentDrawer] = useState('')
    const [data, setData] = useState(undefined);

    useEffect(() => {
        fetchPrograms();
    }, [])

    const handleDropDownValue = (event) => {
        const { name, value } = event?.target;
        setDropDownValue({ [name]: value });
    }

    const fetchPrograms = () => {
        const params = {
            'organisation_id': CoachinRequest?.organisation_id,
        }
        DataService.getDirectData('/programmes', params).then((res) => {
            if (res?.success) {
                setProgramData(res?.programmes)
            }
        }).catch((error) => {
        })
    }

    const handleCreateAssignment = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('crf_id', dropDownValue?.program_id);
        DataService.createData(formData, "create_assignment").then((res) => {
            if (res?.success) {
                setData(res);
                setAssignmentDrawer("create")
            }
        }).catch((error) => {
        })
    }

    return (
        <>
            <Dialog maxWidth={"sm"} fullWidth={true} style={{ height: '70%' }} open={open}
                onClose={onCloseAssignmentModal}
                aria-labelledby="base-station-manage">
                <DialogTitle id="customized-dialog-title" className={classes.dialog_title}>
                    Create new assignment
                </DialogTitle>

                <DialogContent style={{ margin: '0px auto' }}>
                    <div className={classes.formWrapper}>
                        <form onSubmit={handleCreateAssignment}>
                            <div>
                                <Grid container spacing={1} alignItems={"center"} justify={"flex-start"}
                                    style={{ marginBottom: 10 }}>
                                </Grid>
                                <Grid container spacing={1} alignItems={"center"} justify={"flex-start"}>
                                    <Grid item xs={3}>
                                        <Typography variant="subtitle2"
                                            className={classes.title}>Select program</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <FormControl style={{ width: '100%' }} variant="outlined">
                                            <Select
                                                labelId="program_id"
                                                id="program_id"
                                                name='program_id'
                                                onChange={handleDropDownValue}
                                                label="Program">
                                                {programData.map((data) => {
                                                    return (
                                                        <MenuItem name={data?.id}
                                                            value={data?.id}>{data?.name}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems={"center"} justify={"flex-end"}
                                    style={{ marginTop: 20 }}>
                                    <Grid item xs={3}>
                                        <Button disableElevation type="button" style={{ textTransform: 'capitalize' }}
                                            onClick={onCloseAssignmentModal}
                                            variant={"contained"}>Cancel</Button>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Button disableElevation type="submit" style={{ textTransform: 'capitalize' }}
                                            variant={"contained"}
                                            color="primary">
                                            {"Create"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </form>
                    </div>
                </DialogContent>

                {assignmentDrawer === 'create' &&
                    <AssignmentDrawer {...props} handleClose={() => setAssignmentDrawer('')}
                        currentSelection={{ id: data?.assignment_id }} />}
            </Dialog>
        </>
    )
}

export default AssignmentModal
